/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'plus-circle': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M24 13.55c1.15 0 2.1.93 2.1 2.09v6.27h6.26a2.1 2.1 0 1 1 0 4.18H26.1v6.27a2.1 2.1 0 1 1-4.18 0V26.1h-6.27a2.1 2.1 0 1 1 0-4.18h6.27v-6.27c0-1.16.94-2.1 2.09-2.1z"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M1 24a23 23 0 1 1 46 0 23 23 0 0 1-46 0zM24 5.18a18.82 18.82 0 1 0 0 37.64 18.82 18.82 0 0 0 0-37.64z"/>'
  }
})
